export default {
	xname: "Willikers",
	xnumber: "(508) 842-3030",
	xhours: "Hours: 11:30am - 2:00am",
	Starters: [
		{
			name: "Queso Dip",
			price: 5,
		},
		{
			name: "Potato Skins",
			price: 7,
		},
		{
			name: "Cajun BBQ Shrimp Boil",
			price: 8,
		},
		{
			name: "Snack Bites",
			price: 8,
		},
		{
			name: "Onion Rings",
			price: 6,
		},
		{
			name: "Coconut Shrimp",
			price: 8,
		},
		{
			name: "Blackened Chicken Fingers",
			price: 7,
		},
		{
			name: "Nachos",
			price: 7,
		},
		{
			name: "Chicken Fingers",
			price: 7,
		},
		{
			name: "Corn Dog",
			price: 4,
		},
		{
			name: "Jalapeno Poppers",
			price: 7,
		},
		{
			name: "Mozzarella Sticks",
			price: 6,
		},
		{
			name: "Basket of Fries",
			price: 6,
		},
	],
	Soups: [
		{
			name: "N.E. Clam Chowder Soup",
			price: 4,
		},
		{
			name: "Poncho Pete's Chili Soup",
			price: 6,
		},
	],
	Salads: [
		{
			name: "Caesar Salad",
			price: 4,
		},
		{
			name: "Garden Salad",
			price: 5,
		},
		{
			name: "Taco Salad",
			price: 6,
		},
	],
	Wings: [
		{
			name: "Sweet & Sour Wings",
			price: 15,
		},
		{
			name: "Cajun Blackened Wings",
			price: 15,
		},
		{
			name: "Teriyaki Wings",
			price: 15,
		},
		{
			name: "Garlic Parmesan Wings",
			price: 15,
		},
		{
			name: "Honey Mustard Wings",
			price: 15,
		},
		{
			name: "Dixie Fried Wings",
			price: 15,
		},
		{
			name: "Buffalo Wings",
			price: 18,
		},
		{
			name: "Lemon Pepper Wings",
			price: 15,
		},
		{
			name: "Seasame Garlic Wings",
			price: 15,
		},
		{
			name: "Honey BBQ Wings",
			price: 15,
		},
		{
			name: "Mango Habanero Wings",
			price: 15,
		},
	],
	Sandwiches: [
		{
			name: "Chicken Sandwich",
			price: 7,
		},
		{
			name: "Open Steak Sandwich",
			price: 9,
		},
		{
			name: "Texas Brisket Sandwich",
			price: 7,
		},
		{
			name: "BLT Sandwich",
			price: 6,
		},
		{
			name: "Buffalo Chicken Wrap",
			price: 7,
		},
		{
			name: "Burger",
			price: 7,
		},
		{
			name: "Salmon Burger",
			price: 7,
		},
		{
			name: "Pulled Pork Sandwich",
			price: 7,
		},
		{
			name: "Turkey Club Sandwich",
			price: 7,
		},
		{
			name: "Blackened Chicken Wrap",
			price: 7,
		},
		{
			name: "Chicken Caesar Wrap",
			price: 7,
		},
	],
	Pizzas: [
		{
			name: "Mexican Pizza",
			price: 12,
		},
		{
			name: "Chicken Fajita Pizza",
			price: 12,
		},
		{
			name: "Traditional Pizza",
			price: 8,
		},
		{
			name: "BLT Pizza",
			price: 9,
		},
		{
			name: "Pepperoni Pizza",
			price: 9,
		},
		{
			name: "Veggie Pizza",
			price: 9,
		},
		{
			name: "Buffalo Chicken Pizza",
			price: 12,
		},
		{
			name: "BBQ Chicken Pizza",
			price: 12,
		},
	],
	Entrees: [
		{ name: "Catfish", price: 10 },
		{
			name: "Salmon",
			price: 12,
		},
		{
			name: "NY Sirloin",
			price: 17,
		},
		{
			name: "Marinated Tips",
			price: 14,
		},
		{
			name: "Fish 'n Chips",
			price: 10,
		},
	],
	BBQ: [
		{
			name: "Baby Back Ribs",
			price: 26,
		},
		{
			name: "Texas Brisket",
			price: 14,
		},
		{
			name: "Chicken Breast",
			price: 14,
			description: "Grilled, fried, or blackened",
		},
		{
			name: "Chicken",
			price: 12,
		},
		{
			name: "Pulled Pork",
			price: 14,
		},
	],
	Mexican: [
		{
			name: "Enchiladas",
			price: 11,
		},
		{
			name: "Fajitas",
			price: 13,
		},
		{
			name: "Chimichanga",
			price: 11,
		},
		{
			name: "Tacos",
			price: 7,
		},
		{
			name: "Burrito",
			price: 11,
		},
	],
	Sides: [
		{
			name: "Cole Slaw",
			price: 3,
		},
		{
			name: "Mexican Rice",
			price: 3,
		},
		{
			name: "Onion Rings",
			price: 3,
		},
		{
			name: "Sweet Potato Fries",
			price: 3,
		},
		{
			name: "Macaroni & Cheese",
			price: 3,
		},
		{
			name: "Corn",
			price: 3,
		},
		{
			name: "Garlic Mashed Potatoes",
			price: 3,
		},
		{
			name: "French Fries",
			price: 3,
		},
	],
	Desserts: [
		{
			name: "Kahlua Cake",
			price: 5,
		},
		{
			name: "Fried Ice Cream",
			price: 5,
		},
		{
			name: "Chaos Pie",
			price: 5,
		},
		{
			name: "Caramel Apple Pie",
			price: 5,
		},
		{
			name: "Peanut Butter Pie",
			price: 5,
		},
		{
			name: "Ice Cream",
			price: 5,
		},
		{
			name: "Kahlua Cake",
			price: 5,
		},
		{
			name: "Caramel Apple Pie",
			price: 5,
		},
	],
};
